"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLogger = exports.logger = void 0;
exports.logger = {
    extraContext: {},
    setLogger: function (customLogger) {
        var _this = this;
        this.logInfo = function (message, extra) {
            if (extra === void 0) { extra = {}; }
            customLogger === null || customLogger === void 0 ? void 0 : customLogger.logInfo(message, __assign(__assign({}, _this.extraContext), extra));
        };
        this.logWarning = function (message, extra) {
            if (extra === void 0) { extra = {}; }
            customLogger === null || customLogger === void 0 ? void 0 : customLogger.logWarning(message, __assign(__assign({}, _this.extraContext), extra));
        };
        this.logError = function (message, extra) {
            if (extra === void 0) { extra = {}; }
            customLogger === null || customLogger === void 0 ? void 0 : customLogger.logError(message, __assign(__assign({}, _this.extraContext), extra));
        };
    },
    setExtraContext: function (extra) {
        this.extraContext = __assign(__assign({}, this.extraContext), extra);
    },
    logInfo: function () { },
    logWarning: function () { },
    logError: function () { },
};
var validateLogger = function (customLogger) {
    if (!customLogger) {
        return true;
    }
    // @ts-expect-error we don't know if consumers passed all the required methods
    return !!((customLogger === null || customLogger === void 0 ? void 0 : customLogger.logInfo) && (customLogger === null || customLogger === void 0 ? void 0 : customLogger.logWarning) && (customLogger === null || customLogger === void 0 ? void 0 : customLogger.logError));
};
exports.validateLogger = validateLogger;
